import React from 'react';
import Calendar from './components/Calendar';
import './App.css';

function App() {
  return (
    <div className="app">
      <main className="page">
        <p className="page__hint">
          Clique em um dia no calendário ou use <strong>Nova reserva</strong> para agendar.
        </p>
        <section className="calendar-card">
          <Calendar />
        </section>
      </main>
    </div>
  );
}

export default App;
